import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import * as Parse from 'parse';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';


@Component({
  selector: 'app-motivationscore',
  templateUrl: './motivationscore.component.html',
  styleUrls: ['./motivationscore.component.css']
})
export class MotivationscoreComponent implements OnInit {
  score : Number = Number(this.cookie.get("motivationScore"));
  atRisk : boolean = false;

  constructor(
    private router : Router,
    private _bkoffService : BackOffServiceService,
    private cookie : CookieService
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
   }

  ngOnInit() {
    this.checkRisk();
    console.log(this.score);
  }

  checkRisk() {
    if (this.score >= 5) {
      this.atRisk = true;
    }
  }

  gotoProgram(){
    this.router.navigateByUrl('/program');
  }
}
